import LoaderComponent from "./LoaderComponent";

export default LoaderComponent;